
import { computed, defineComponent } from "@vue/runtime-core";

export default defineComponent({
  inheritAttrs: true,
  props: {
    color: {
      type: String,
      default: () => "blue",
      validator: (value: string) => {
        // The value must match one of these strings
        return (
          [
            "primary",
            "secondary",
            "accent",
            "gray",
            "black",
            "blue",
            "green",
            "red",
            "white",
            "yellow",
          ].indexOf(value) !== -1
        );
      },
    },
  },
  setup(props) {
    const classNames = computed(() => {
      return `button button--text-${props.color}`;
    });

    return {
      classNames,
    };
  },
});
